<script setup>
// A list of short texts edited in place (suggested phrasings, ways to ask, things not to do): one field per item,
// a remove button on each and an "Add" below. The page owns the list; an empty item is dropped when the step is saved.
import { Add16, Close16 } from '@carbon/icons-vue';
import { useI18n } from 'vue-i18n';
import { Button } from 'dashboard/components-next/polaris/ui/button';
import { Input } from 'dashboard/components-next/polaris/ui/input';
import { Textarea } from 'dashboard/components-next/polaris/ui/textarea';

const props = defineProps({
  label: { type: String, required: true },
  addLabel: { type: String, required: true },
  placeholder: { type: String, default: '' },
  multiline: { type: Boolean, default: false },
  invalid: { type: Boolean, default: false },
});
const items = defineModel({ type: Array, default: () => [] });
const { t } = useI18n();

const setItem = (index, value) => {
  items.value = items.value.map((item, at) => (at === index ? value : item));
};
const removeItem = index => {
  items.value = items.value.filter((_, at) => at !== index);
};
const addItem = () => {
  items.value = [...items.value, ''];
};
</script>

<template>
  <div class="grid gap-2" data-string-list>
    <div
      v-for="(item, index) in items"
      :key="index"
      class="flex items-start gap-2"
    >
      <Textarea
        v-if="props.multiline"
        :model-value="item"
        :aria-label="`${props.label} ${index + 1}`"
        :aria-invalid="props.invalid || undefined"
        :placeholder="props.placeholder"
        class="min-h-16 flex-1"
        @update:model-value="value => setItem(index, value)"
      />
      <Input
        v-else
        :model-value="item"
        :aria-label="`${props.label} ${index + 1}`"
        :aria-invalid="props.invalid || undefined"
        :placeholder="props.placeholder"
        class="flex-1"
        @update:model-value="value => setItem(index, value)"
      />
      <Button
        type="button"
        variant="ghost"
        size="icon"
        :aria-label="t('POLARIS.ASSISTANTS.SCENARIOS.SCRIPT.REMOVE_ITEM')"
        @click="removeItem(index)"
      >
        <Close16 aria-hidden="true" />
      </Button>
    </div>
    <div>
      <Button type="button" variant="ghost" size="sm" @click="addItem">
        <Add16 aria-hidden="true" />
        {{ props.addLabel }}
      </Button>
    </div>
  </div>
</template>
